module.exports = __webpack_public_path__ + "img/35.ca711912.jpg";